import './style.less';
import * as React from 'react';
import { Button } from 'telstra-ui/components/button/Button';
import { loading } from '@redux/actions';
import { connect } from 'react-redux';
import { withRouter, IWithRouterProps } from '@utils/withRouterWrapper';
import { ActivityTracking } from '@telstra-connect/billing';

// eslint-disable-next-line @typescript-eslint/no-var-requires, no-undef
const serverErrorLarge = require('../../../../images/Server-Error-Large.svg');

interface IPageLoadingIndicatorDispatchProps {
    showGlobalSpinner: () => void;
    hideGlobalSpinner: () => void;
}

interface IPageLoadingIndicatorProps extends IPageLoadingIndicatorDispatchProps {
    error: boolean;
}

class PageLoadingIndicatorComponent extends React.Component<IPageLoadingIndicatorProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { error } = this.props;

        if (error) {

            return this.renderPageLoadError();
        }

        this.props.showGlobalSpinner();
        return null;
    }

    public componentWillUnmount() {
        this.props.hideGlobalSpinner();
    }
    private readonly renderPageLoadError = () => {
        this.props.hideGlobalSpinner();
        return this.renderPageCenter(
            <div>
                <div className="tc-billing-page-load-indicator">
                    <img src={serverErrorLarge} />
                </div>
                <span className="tc-billing-page-load-failed-text">
                    Failed to load the requested resource
                </span>
                <div className="tc-billing-try-again">
                    <Button onClick={this.tryAgain}>Try again</Button>
                </div>
            </div>
        );
    }

    private readonly renderPageCenter = (component) => (
        <div className="tc-billing">
            <div id="tc-billing-page-load-center">
                <div className="tc-billing-page-load-indicator-container">
                    {component}
                </div>
            </div>
        </div>
    )

    private readonly tryAgain = () => window.location.reload()
}

const mapDispatchToProps = (dispatch): IPageLoadingIndicatorDispatchProps => ({
    showGlobalSpinner: () => dispatch(loading(true)),
    hideGlobalSpinner: () => dispatch(loading(false)),
});

export const PageLoadingIndicator =
withRouter(connect<null, IPageLoadingIndicatorDispatchProps, IWithRouterProps>
(null, mapDispatchToProps)(PageLoadingIndicatorComponent));
